import store from "@src/_store/store";
import Pusher from "pusher-js";
import * as PusherPushNotifications from "@pusher/push-notifications-web";

export default {
    install(Vue) {
        Vue.prototype.$initChannels = function (cbs) {
            initChannels(Vue, cbs);
        };
        Vue.prototype.$initBeams = function () {
            initBeams();
        };
        Vue.prototype.$closePusher = function () {
            if (pusherInstance) {
                pusherInstance.disconnect();
                pusherInstance = null;
            }
        };
        Vue.prototype.$closeBeams = function () {
            try {
                return beamsClient.stop()
                                  .then(() => {
                                      console.log("Beams stopped");
                                  })
                                  .catch((error) => {
                                      console.error("Error stopping Beams:", error);
                                  });
            } catch (error) {
            }
        };
    },
};

let pusherInstance = null;
let privateChannel = null;
let beamsClient = null;


function initBeams() {
    window.navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
        beamsClient = new PusherPushNotifications.Client({
            instanceId: process.env.VUE_APP_BEAMS_KEY,
            serviceWorkerRegistration: serviceWorkerRegistration,
        });

        const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
            url: `${process.env.VUE_APP_API_URL}/pusher/token`,
            headers: {
                Authorization: `Bearer ${store.getters["auth/getState"].token}`,
            },
        });

        try {
            beamsClient.start()
                       .then(() => beamsClient.getDeviceId())
                       .then(() => beamsClient.setUserId(`${store.getters["auth/getState"].userId}`, beamsTokenProvider))
                       .then(() => console.log("Beams connected"))
                       .catch((error) => {
                           console.error("Beams initialization error:", error);
                       });
        } catch (error) {
            console.error("Beams initialization error:", error);
        }
    });
}

function initChannels(Vue, cbs) {
    const channelName = `private-user-${store.getters["auth/getState"].userId}`;

    if (pusherInstance) {
        pusherInstance.disconnect();
        pusherInstance = null;
    }

    initializePusher();

    Vue.prototype.$closePusher = function () {
        if (pusherInstance) {
            pusherInstance.disconnect();
            pusherInstance = null;
        }
    };

    function initializePusher() {
        pusherInstance = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
            forceTLS: true,
            cluster: process.env.VUE_APP_PUSHER_CLUSTER,
            channelAuthorization: {
                endpoint: `${process.env.VUE_APP_API_URL}/pusher/auth`,
                transport: "ajax",
                headers: {
                    Authorization: `Bearer ${store.getters["auth/getState"].token}`,
                },
            },
            enabledTransports: ["ws", "wss", "xhr_streaming", "xhr_polling", "sockjs"],
            retryStrategy: (attempt) => {
                return Math.min(1000 * 2 ** attempt, 30000);
            },
            activityTimeout: 60000,
            pongTimeout: 10000,
        });

        pusherInstance.connection.bind("connected", () => {
            console.log("Pusher connected");
            subscribeToChannel();
        });

        pusherInstance.connection.bind("disconnected", () => {
            console.log("Pusher disconnected");
        });

        pusherInstance.connection.bind("error", (err) => {
            console.error("Pusher connection error:", err);
        });
    }

    function subscribeToChannel() {
        if (privateChannel) {
            pusherInstance.unsubscribe(channelName);
        }
        privateChannel = pusherInstance.subscribe(channelName);

        const eventHandlers = {
            RefreshListNotification: () => {
                cbs.getNotifications();
            },
            BackOfficeUserLoginDetails: (cultureName) => {
                cbs.loginInternalDetails(store.getters["auth/getState"].token, cultureName, true);
            },
            RefreshListRequestManager: () => {
                store.commit("requestManager/setRequestsStateChanged");
            },
            NewMessageRequestManager: (newMessage) => {
                let messagesState = store.getters["requestManager/getMessagesState"] || [];
                messagesState = [...messagesState, newMessage];
                store.commit("requestManager/setNewMessageReceived", messagesState);
            },
            ReadMessageRequestManager: (obj) => {
                let messagesReadState = store.getters["requestManager/getMessagesReadState"] || [];
                messagesReadState = [...messagesReadState, obj.ticketId];
                store.commit("requestManager/setNewMessageRead", messagesReadState);
            },
            RefreshMyGarageDashboard: () => {
                cbs.getGarageIndicators();
            },
            TipsWorkerExportExcelEntities: (data) => {
                cbs.showSnackbar(data.Name === "ERROR", data.Value);
            },
            RefreshQuotationHistory: () => {
                cbs.QuotationHistory();
            }
        };

        Object.keys(eventHandlers).forEach((eventName) => {
            privateChannel.bind(eventName, eventHandlers[eventName]);
        });
    }
}

export function registerServiceWorker() {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/service-worker.js')
                     .catch(error => {
                         console.error('Error registering service worker:', error);
                     });
        });
    } else {
        console.warn('Push API not supported.');
    }
}